import(/* webpackMode: "eager", webpackExports: ["RecentlyViewed"] */ "C:\\Users\\Bradl\\GitHub\\noirpetale\\app\\RecentlyViewed.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AddToCart"] */ "C:\\Users\\Bradl\\GitHub\\noirpetale\\app\\shop\\[slug]\\AddToCart.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductGallery"] */ "C:\\Users\\Bradl\\GitHub\\noirpetale\\app\\shop\\[slug]\\ProductGallery.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StickyMobileBuyBar"] */ "C:\\Users\\Bradl\\GitHub\\noirpetale\\app\\shop\\[slug]\\StickyMobileBuyBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TrackProductView"] */ "C:\\Users\\Bradl\\GitHub\\noirpetale\\app\\shop\\[slug]\\TrackProductView.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VariantPrice"] */ "C:\\Users\\Bradl\\GitHub\\noirpetale\\app\\shop\\[slug]\\VariantPrice.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VariantSelector"] */ "C:\\Users\\Bradl\\GitHub\\noirpetale\\app\\shop\\[slug]\\VariantSelector.tsx");
;
import(/* webpackMode: "eager" */ "C:\\Users\\Bradl\\GitHub\\noirpetale\\app\\WishlistButton.tsx");
;
import(/* webpackMode: "eager" */ "C:\\Users\\Bradl\\GitHub\\noirpetale\\node_modules\\next\\dist\\client\\app-dir\\link.js");
;
import(/* webpackMode: "eager" */ "C:\\Users\\Bradl\\GitHub\\noirpetale\\node_modules\\next\\dist\\client\\image-component.js");
